import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 11 9",
  "content": "<symbol viewBox=\"0 0 11 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-check\">\n<path d=\"M1 4L4 7L10 1\" stroke=\"\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol